import { useEffect } from 'react'

// Ctrl/Cmd + tecla: imprimir, salvar, copiar, recortar, selecionar tudo, ver código-fonte
const BLOCKED_SHORTCUT_KEYS = new Set(['p', 's', 'c', 'x', 'a', 'u'])

const preventDefault = (event: Event) => event.preventDefault()

/**
 * Dissuasão contra cópia do conteúdo enquanto a página está montada: bloqueia atalhos de
 * teclado, menu de contexto (inclui o "segurar" no celular), cópia, arrasto e impressão.
 *
 * Não impede capturas do sistema operacional (PrintScreen, Win+Shift+S, botões do celular) —
 * para isso a proteção é a marca d'água.
 */
export function useContentProtection() {
	useEffect(() => {
		const handleKeyDown = (event: KeyboardEvent) => {
			const key = event.key.toLowerCase()
			if ((event.ctrlKey || event.metaKey) && BLOCKED_SHORTCUT_KEYS.has(key)) {
				event.preventDefault()
				event.stopPropagation()
			}
		}

		// O PrintScreen só é notificado depois da captura; limpar a área de transferência
		// evita que a imagem seja colada direto (melhor esforço, depende do navegador).
		const handleKeyUp = (event: KeyboardEvent) => {
			if (event.key === 'PrintScreen') {
				void navigator.clipboard?.writeText('').catch(() => {})
			}
		}

		window.addEventListener('keydown', handleKeyDown, { capture: true })
		window.addEventListener('keyup', handleKeyUp, { capture: true })
		document.addEventListener('contextmenu', preventDefault)
		document.addEventListener('copy', preventDefault)
		document.addEventListener('cut', preventDefault)
		document.addEventListener('dragstart', preventDefault)
		document.addEventListener('selectstart', preventDefault)

		return () => {
			window.removeEventListener('keydown', handleKeyDown, { capture: true })
			window.removeEventListener('keyup', handleKeyUp, { capture: true })
			document.removeEventListener('contextmenu', preventDefault)
			document.removeEventListener('copy', preventDefault)
			document.removeEventListener('cut', preventDefault)
			document.removeEventListener('dragstart', preventDefault)
			document.removeEventListener('selectstart', preventDefault)
		}
	}, [])
}
